'use client';

import { TopBanner } from '../../_components/TopBanner';
import { useTopBanner } from '../_hooks/useTopBanner';

export const TopBannerContainer = () => {
  const topBanner = useTopBanner();

  if (!topBanner) return null;

  return <TopBanner {...topBanner} />;
};
